<template>
  <div>
    <!-- 新增系列产品 -->
    <el-dialog
      title="新增系列产品"
      :visible.sync="dialogFormVisible"
      width="650px"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="商品系列标题:" label-width="120px">
          <el-input placeholder="请输入商品系列标题" v-model="seriesTitle" size="small"></el-input>
        </el-form-item>
        <el-form-item label="上传商品图片:" label-width="120px">
          <upload-img ref="uploadImgs" :fatherMethod="fatherMethod" :singleImg="singleImg"></upload-img>
        </el-form-item>
      </el-form>
      <div class="addSeries">
        <div class="btns" style="text-align:center;">
          <el-button size="small" type="primary" @click="getShopcategoryAdd">确 定</el-button>
          <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { shopcategoryAdd } from "../service";
import uploadImg from "./uploadImg"
export default {
  props: {
    changeGoodSeries: {
      type: Function,
      default: null
    },
    singleImg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogFormVisible: false,
      seriesTitle:null,//标题
      form:{}
    };
  },
  methods: {
    getShopcategoryAdd() {
      this.$refs.uploadImgs.$emit("bridge", true);
    },
    // 确定新增系列产品后，等图片上传成功之后，子组件uploadImg再调用父组件方法
    fatherMethod(pic) {
      let params = {
        name: this.seriesTitle,
        pic
      };
      shopcategoryAdd(params).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: "提交成功",
            type: "success"
          });
          // 调用父组件方法,将新增系列的标题传到商品管理中去
          this.changeGoodSeries(this.seriesTitle);
          this.dialogFormVisible = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    open(){
      this.dialogFormVisible = true;
    }
  },
  components: {
    uploadImg
  }
};
</script>

<style lang="less" scoped>
</style>